import Swagger from 'swagger-client';

import { encodeCS } from "../utils/JSONWebToken";
import {i18nStore} from "../stores/StoreLoader";
import {getSessionId} from "../utils/SchoolBlocksUtilities";
import {ExecutionEnvironment} from "../stores/InterfaceStore";
import {getConfig} from "../_configs/AppConfig";
const {publicRuntimeConfig} = getConfig();


function createSingleton(swaggerAuthorization): Swagger {
    return new Swagger({
        url: publicRuntimeConfig.API_SPEC_URL,
        usePromise: true,
        debug: true,
        authorizations: {
            api_key: swaggerAuthorization,
        },
    });
}

let swaggerSingleton: Swagger | null = null;

export default function WatsonApi(orgId: string | null | undefined = null, userId: string | null | undefined = null, spinup = false, facebookUserAccessToken: string | null | undefined = null) {
    const swaggerAuthorization = buildSwaggerAuthorization(orgId, userId, spinup, facebookUserAccessToken);

    if (!swaggerSingleton) {
        swaggerSingleton = createSingleton(swaggerAuthorization);
    }

    swaggerSingleton.then(client => client.clientAuthorizations.add("api_key", swaggerAuthorization));

    return swaggerSingleton;
}

export function buildSwaggerAuthorization(orgId, userId, spinup, facebookAccessToken) {
    const language = i18nStore.currentOrgSupportedLocale;
    const sessid = ExecutionEnvironment.canUseDOM ? getSessionId(document.cookie) : "";
    const apiKey = encodeCS(orgId, userId, publicRuntimeConfig.API_KEY, spinup, facebookAccessToken, language, sessid);
    return new Swagger.ApiKeyAuthorization('api-key', apiKey, 'header');
}
